import {KTSVG} from '../../../_metronic/helpers'
import React, {FC, forwardRef, useEffect, useState} from 'react'
import { Mainsubtable } from '../../tables/Mainsubtable'
import {Modal} from 'react-bootstrap'
import { Mainsubtable2 } from '../../tables/Mainsubtable2'
import {Column} from 'react-table'
import {useWindowWidth} from '@react-hook/window-size/throttled'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)


type Props = {
  statedeletinginvoice: boolean
  show: boolean
  handleClose: () => void
  invoicetodelete: any
  deleteInvoiceSales: () => void

}

const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME

export const Deleteorder: FC<Props> = forwardRef((props, ref) => {
 
  const truncate = require('truncate')
  const onlyWidth = useWindowWidth()

  const columndata2: ReadonlyArray<
  Column<{
    sales_id: number
    quantity: number
    unit_price: number
    sub_total: number
    product_id: number
    products_unit: number
    discount_percentage: number
    product_unit_id: number
    user_id: number
    sales_invoice_id: string
    datesold: string
    sales_status: string
    product_name: string
    unit_name: string
 
  }>
> = [
  {
    Header: 'Salesid',
    accessor: 'sales_id',

    Cell: ({cell: {value}, row}) => (
      <>
        <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
      </>
    ),
  },
  {
    Header: 'Product',
    accessor: 'product_id',

    Cell: ({cell: {value}, row}) => (
      <>
        <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
          {truncate(row.original.product_name, 20)}
        </span>

        <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>{value}</span>
      </>
    ),
  },

  {
    Header: 'Quantity',
    accessor: 'quantity',

    Cell: ({cell: {value}, row}) => (
      <>
        <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
        <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
          {row.original.unit_name}
        </span>
      </>
    ),
  },

  {
    Header: 'Price',
    accessor: 'unit_price',

    Cell: ({cell: {value}, row}) => (
      <>
        <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
          {addCommas(value.toFixed(2))} {CURRENCY_APP}
        </span>

        <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
          {row.original.discount_percentage}% OFF
        </span>
      </>
    ),
  },
  {
    Header: 'Total',
    accessor: 'sub_total',

    Cell: ({cell: {value}, row}) => (
      <>
        <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
          {addCommas(value.toFixed(2))} {CURRENCY_APP}
        </span>
      </>
    ),
  },
]

const columndata4: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      products_unit: number
      discount_percentage: number
      product_unit_id: number
      unit_name: string
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
    }>
  > = [
    {
      Header: 'Product',
      accessor: 'product_id',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
            {truncate(row.original.product_name, 20)}

            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span>{row.original.quantity}</span>
          </span>

          <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
            {dayjs(row.original.datesold).calendar()}
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            {addCommas(row.original.sub_total.toFixed(2))} {CURRENCY_APP}{' '}
          </span>
        </>
      ),
    },
  ]


 const columndata6: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      products_unit: number
      discount_percentage: number
      product_unit_id: number
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
      unit_name: string
    }>
  > = [
    {
      Header: 'Product',
      accessor: 'product_id',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
            {truncate(row.original.product_name, 20)}
          </span>

          <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
            Product Id {value}
          </span>
        </>
      ),
    },

    {
      Header: 'Quantity',
      accessor: 'quantity',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
          <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
            {row.original.unit_name}
          </span>
        </>
      ),
    },

    {
      Header: 'Price',
      accessor: 'unit_price',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {addCommas(value.toFixed(2))} {CURRENCY_APP}
          </span>

          <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
            Discount: {row.original.discount_percentage}%
          </span>
        </>
      ),
    },
    {
      Header: 'Total',
      accessor: 'sub_total',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {addCommas(value.toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
  ]

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Delete Invoice
          <span className='h-10px border-gray-200 border-start mx-2'></span>

           <span className='text-muted fw-bold fs-6'>{props.invoicetodelete.invoice_id}</span>
          
          </h3>
          

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
        <div className='fv-row mb-7'>
              <div className='card bg-light'>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='required card-label fw-bolder fs-5 mb-1'>Invoice Summary</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>
                      {props.invoicetodelete.sales_info?.length == 1
                        ? `${props.invoicetodelete.sales_info?.length} item in invoice`
                        : `${props.invoicetodelete.sales_info?.length} items in invoice`}
                    </span>
                  </h3>
                  
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                  
                
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}

                    <Mainsubtable2
                      columnaddedtitems={onlyWidth <= 500
                        ? columndata4
                        : onlyWidth <= 720
                        ? columndata6
                        : columndata2}
                      adddatatable={props.invoicetodelete.sales_info}
                    />

                    {/* end::Table */}
                   
                  </div>
                  {/* end::Table container */}
                </div>
                {/* begin::Body */}
              </div>
            </div>

          <span className='required fw-bold fs-5 mb-2'>
            Are you sure you want to delete the above invoice ?
          </span>

        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={props.deleteInvoiceSales}
            disabled={props.statedeletinginvoice}
          >
            {!props.statedeletinginvoice && <span className='indicator-label'>Delete Invoice</span>}
            {props.statedeletinginvoice && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
